import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { debounce } from '@material-ui/core';

import { errorMsg, successMsg } from '../config';
import { MSG } from '../msg-const';
import utils from '../utils';
import AddFund from './Modals/AddFund';
import { MainContext } from './../contexts/MainContext';
import NFTBuckCard from './MarketHub/Common/Cards/NFTBuck';
import BundleCard from './MarketHub/Common/Cards/Bundle';

import { ReactComponent as DeleteImg } from '../img/svg/Actions/Delete.svg';
import { ReactComponent as BackIconArrow } from '../img/svg/Arrows/BackArrow.svg';
import { ReactComponent as CartIcon } from '../img/svg/Assets/CartIcon.svg';
import { ReactComponent as AlertIcon } from '../img/svg/Actions/AlertRed.svg';

export default class CartSlide extends React.Component {
  static contextType = MainContext;
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.prop.cart,
      usdcBalance:
        this.props.prop.balance && this.props.prop.balance.usdcBalance
          ? this.props.prop.balance.usdcBalance
          : '',
      cartData: [],
      quantityList: [],
      supplyError: [],
      totalCheckoutAmount: 0,
      isActive: true,
      totalBucks: 0,
      totalBundle: 0
    };
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    // const mainContext = this.context;
    this.prepareList();
  }

  componentWillReceiveProps(newProps) {
    this.setStateFromWithNewProps(newProps.prop);
  }

  async setStateFromWithNewProps(props) {
    if (!props.fetchingCartDetails) {
      await this.setState({
        data: props.cart,
        usdcBalance:
          props.balance && props.balance.usdcBalance
            ? props.balance.usdcBalance
            : '',
        cartData: [],
        quantityList: [],
        totalCheckoutAmount: 0,
        isActive: true,
        show: false
      });
      this.prepareList();
    }
  }

  componentWillUnmount() {
    this.handleToggle('closeall');
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  async prepareList() {
    if (!this.state.data) {
      return;
    }
    let list = [];
    let totalBucks = 0;
    let totalBundle = 0;
    let totalCheckoutAmount = 0;
    if (this.state.data.buckInfo && this.state.data.buckInfo.length > 0) {
      for (let obj of this.state.data.buckInfo) {
        obj.type = 'buck';
        totalBucks = totalBucks + obj.quantity * 1;
        list.push(obj);
      }

      totalCheckoutAmount =
        totalCheckoutAmount + Number(this.state.data.buckTotalPrice);
    }

    if (this.state.data.bundleInfo && this.state.data.bundleInfo.length > 0) {
      for (let obj of this.state.data.bundleInfo) {
        obj.type = 'bundle';
        totalBundle = totalBundle + 1;
        list.push(obj);
      }
      totalCheckoutAmount =
        totalCheckoutAmount + Number(this.state.data.bundleTotalPrice);
    }
    await this.setState({
      cartData: [...list],
      quantityList: list.map(({ quantity = '1' }) => quantity),
      supplyError: list.map((error) => false),
      totalCheckoutAmount: totalCheckoutAmount,
      totalBucks: totalBucks,
      totalBundle: totalBundle
    });

    let totalbucks = this.state.totalBucks;
    list.forEach((e) => {
      if (e?.type === 'bundle') {
        e?.bucksArray?.forEach((buck) => {
          const product = buck?.quantity * e?.quantity;
          totalbucks = totalbucks + product;
        });
      }
    });
    this.setState({ totalBucks: totalbucks });
  }

  onValueChange(event, index) {
    let quantityList = [...this.state.quantityList];
    if (!event.target.value) {
      quantityList[index] = '';
      return this.setState({ quantityList: quantityList });
    }
    var num = Number(event.target.value);
    if (!isNaN(num) && num < 10000000000) {
      let dec = (event.target.value + '').split('.');
      if (dec.length > 1) return;
      quantityList[index] = num;
      this.setState({ quantityList: quantityList });
      this.debouncedUpdateCart(index);
    }
  }

  debouncedUpdateCart = debounce(
    (index = 0) => this.updateCart(this.state.cartData[index], index),
    500
  );

  async updateCart(e, index = 0) {
    try {
      if (Number(e.quantity) > 0) {
        let cartObj = {
          type: e.type,
          quantity: this.state.quantityList[index] || e.quantity,
          itemId: e._id,
          cartId: this.state.data._id
        };
        const res = await this.props.prop.apiUtility.updateCart(cartObj);
        let supply_error = [...this.state.supplyError];
        if (res.status === 400) {
          supply_error[index] = true;
          errorMsg(res.message);
        } else {
          this.props.callback({ fnName: 'getCart' });
          successMsg('Item count updated');
        }
        this.setState({ supplyError: supply_error });
      } else {
        errorMsg(MSG.ENTER_VALID_AMOUNT);
      }
    } catch (e) {}
  }

  async onDeleteItem(e, index) {
    try {
      let cartObj = {
        type: e.type,
        quantity: 0,
        itemId: e._id,
        cartId: this.state.data._id
      };
      await this.props.prop.apiUtility.updateCart(cartObj);
      this.props.callback({ fnName: 'getCart' });
      successMsg('Item Deleted successfully');
      let supply_error = [...this.state.supplyError];
      supply_error.splice(index, 1);
      this.setState({ supplyError: supply_error });
    } catch (e) {}
  }

  async clearCart() {
    try {
      let cartObj = {
        cartId: this.state.data._id
      };
      await this.props.prop.apiUtility.clearCart(cartObj);
      this.props.callback({ fnName: 'getCart' });
    } catch (e) {}
  }

  getCards() {
    if (!this.state.cartData || this.state.cartData.length <= 0) {
      return (
        <h6
          style={{ textAlign: 'center', marginTop: '20px', color: '#5a51ff' }}
        >
          You don't have any item!
        </h6>
      );
    }
    return this.state.cartData.map((e, key) => {
      let raritycount = [];
      if (e?.type === 'bundle') {
        raritycount = utils.getBuckRarityCount(e?.bucksArray);
      }
      return (
        <div className="list-cart-box d-flex mb-5 mt-3" key={key}>
          <div className="img-carrt">
            {e?.type === 'bundle' ? (
              <BundleCard
                cardImageOnly
                data={{ ...e, rarityCount: raritycount }}
              />
            ) : (
              <NFTBuckCard cardImageOnly data={{ imagePath: e.imagePath }} />
            )}
          </div>
          <div className="text-cart-list px-4">
            <h6>{e.title}</h6>
            <div className="quantity d-flex">Quantity</div>
            <div className="d-flex align-items-center mob-wrap">
              <input
                min={1}
                className="quantity-input my-2 w-100"
                type="number"
                value={this.state.quantityList[key]}
                onChange={($event) => this.onValueChange($event, key)}
              />
              {/* <Button
                className="update-btn me-2"
                onClick={() => {
                  this.updateCart(e, key);
                }}
              >
                Update
              </Button> */}
              <div
                className="delete cursor-pointer"
                onClick={() => this.onDeleteItem(e, key)}
              >
                <DeleteImg />
              </div>
            </div>
            {this.state.supplyError[key] && (
              <span className="text-pink">
                Insufficeint quantity to add in cart
              </span>
            )}
            <div className="cart-price mt-4">${e.itemTotalPrice}</div>
          </div>
        </div>
      );
    });
  }

  clearAllBtn() {
    if (!this.state.cartData || this.state.cartData.length <= 0) {
      return;
    }
    return (
      <Button className="mb-4" onClick={() => this.clearCart()}>
        Clear All
      </Button>
    );
  }

  handleToggle(closeall) {
    const mainContext = this.context;
    if (!mainContext.isWalletSlideOpen) {
      mainContext.setWalletSlide(!mainContext.isWalletSlideOpen);
    }
    mainContext.setCartSlide(!mainContext.isCartSlideOpen);
    if (closeall) {
      mainContext.setWalletSlide(true);
      mainContext.setCartSlide(true);
    }
    this.props?.setOpen?.(false);
  }
  handleOutsideClick = (e) => {
    if (e.target.id === document.getElementById('cart-content-area').id) {
      this.handleToggle('closeall');
    }
  };

  render() {
    const mainContext = this.context;
    return (
      <>
        <Button
          onClick={() => this.handleToggle()}
          className="p-0 nav-link cart-nav-item position-relative"
        >
          <CartIcon />
          <span className="total-cart position-absolute">
            {this.state.cartData ? this.state.cartData.length : 0}
          </span>
          <div className="hover-open-dropdown position-absolute">
            <div className="d-flex justify-content-center align-items-center h-100">
              <Link to="/">
                You have {this.state.cartData ? this.state.cartData.length : 0}{' '}
                new items in your cart!
              </Link>
            </div>
          </div>
        </Button>
        <div
          id="cart-content-area"
          onClick={(e) => this.handleOutsideClick(e)}
          className={
            mainContext.isCartSlideOpen
              ? 'cart-slide-right cart-none'
              : 'cart-slide-right'
          }
        >
          <div className="cart-bg text-white">
            <div className="cart-heading  d-flex text-white justify-content-between px-4 pt-4  mob-wrap">
              <div className="d-flex justify-content-between align-items-center">
                <Button
                  onClick={() => {
                    this.handleToggle();
                  }}
                  className="p-0 bg-cart-close"
                >
                  <BackIconArrow />
                </Button>
                <h3 className="ms-4 mt-2">
                  <CartIcon className="me-2" /> My Cart
                </h3>
              </div>
              <h3 className="cart-balance">
                <span>Bucks Balance</span> $
                {Number(mainContext.totalBucksValue || 0)} USD
              </h3>
            </div>
            <div className="text-right px-4 mb-3 pt-2 need-crypto-text">
              <div className="need-crypto-text">
                Need Crypto?
                <AddFund needCrypto />
              </div>
            </div>
            <div className="main-heading mb-3 px-4 pt-4">
              <h1>
                You have{' '}
                <span className="text-blue">
                  {this.state.cartData ? this.state.cartData.length : 0}{' '}
                </span>
                Item(s)
              </h1>
            </div>
            <div className="liat-cart-slide px-4">
              {this.getCards()}
              {this.clearAllBtn()}
            </div>
            <div className="summary p-4">
              <h5>Summary</h5>
              <div className="sumary-text d-flex justify-content-between mb-2 mt-3">
                Total cart value <span>${this.state.totalCheckoutAmount}</span>
              </div>
              <div className="sumary-text d-flex justify-content-between">
                Total RWA Bucks in Cart{' '}
                <span>
                  {this.state.totalBucks}{' '}
                  {this.state.totalBucks === 0 ? (
                    <AlertIcon style={{ height: '20px', width: '20px' }} />
                  ) : null}
                </span>
              </div>
            </div>
            {this.state.cartData &&
            this.state.cartData.length > 0 &&
            this.state.supplyError.every((error) => !error) ? (
              <div className="checkout-action">
                <Link to="/ProceedToCheckout">
                  <Button onClick={() => this.handleToggle()}>
                    Proceed to checkout
                  </Button>
                </Link>
              </div>
            ) : (
              <div
                className="checkout-action"
                style={{ cursor: 'not-allowed' }}
              >
                <Button disabled={true} style={{ cursor: 'not-allowed' }}>
                  Proceed to checkout
                </Button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}
